import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { forwardRef, memo } from 'react'

import styles from './Select.module.scss'

export type SelectProps = JSX.IntrinsicElements['select'] & {
  items: {
    label: string
    value: string
  }[]
}
const SelectInner = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className = '', items = [], ...props }, ref) => {
    return (
      <div className={`${styles.root} ${className}`}>
        <select ref={ref} {...props}>
          {items.map((item, index) => {
            return (
              <option value={item.value} key={index}>
                {item.label}
              </option>
            )
          })}
        </select>
        <div className={styles.root__icon}>
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </div>
    )
  },
)

export const Select = memo(SelectInner)
